import { createVue3AppPackage } from '@fiksu/vue3-app';
import { configureApp } from './layout';
export default createVue3AppPackage(async () => (await import('../components/oasis-header.vue')).default, (app) => configureApp(app));
